import { trackPromise } from 'react-promise-tracker'
import log from 'loglevel'
const api = (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'http:' ? 'http://' + window.location.hostname + ':3080' : (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'https:' ? 'https://' + window.location.hostname + ':8443' : process.env.REACT_APP_API_URL

export const getWeblogList = (unitID, currentTimestamp, offsetNumber, totalPerPage, setData) => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const accountID = accountId

    const body = { currentTimestamp, offsetNumber, totalPerPage }

    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountID}/weblog/${unitID}`, options))

    if (!response.status || response.status === 401 || response.status === 500) {
      log.warn('Could not get weblog data.')
    } else {
      const fullData = await response.json()
      setData(fullData)
    }
  }
}
